module.exports = __webpack_public_path__ + "img/tripadvisor-certificate-2019.2f98334d.webp";